import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { addTeam, AddTeamRequest, AddTeamResponse, API_QUERY_KEYS } from 'api';

export const useAddTeam = (
  options?: UseMutationOptions<AddTeamResponse, unknown, AddTeamRequest>
): UseMutationResult<AddTeamResponse, unknown, AddTeamRequest> => {
  const queryClient = useQueryClient();
  return useMutation(addTeam, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageTeamConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getTeams] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getAllTeams] });
    },
    ...options,
  });
};
